<template>
  <div class="content">
    <el-row>
      <el-col :span="4">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_ldttitle1.png')" class="titleimg" />
      </el-col>
    </el-row>
    <el-row class="one">
      <img v-lazy="require('../../assets/imgs/iphone_ldtpage1.png')" class="img" />
    </el-row>
    <el-row class="two">
      <img v-lazy="require('../../assets/imgs/iphone_ldtpage2.png')" class="img" />
    </el-row>
    <el-row class="three">
      <img v-lazy="require('../../assets/imgs/iphone_ldtpage3.png')" class="img" />
    </el-row>
    <el-row class="four">
      <img v-lazy="require('../../assets/imgs/iphone_ldtpage4.png')" class="img" />
    </el-row>
    <el-row class="five">
      <img v-lazy="require('../../assets/imgs/iphone_ldtpage5.png')" class="img" />
    </el-row>
    <el-row class="six">
      <img v-lazy="require('../../assets/imgs/iphone_ldtpage6.png')" class="img" />
    </el-row>
    <el-row>
      <el-col :span="4">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_ldttitle2.png')" class="titleimg" />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="6">
        <img v-lazy="require('../../assets/imgs/iphone_1.png')" class="iconimg" />
        <p>本地特色</p>
        <img v-lazy="require('../../assets/imgs/iphone_3.png')" class="iconimg" />
        <p>配音</p>
      </el-col>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="6">
        <img v-lazy="require('../../assets/imgs/iphone_2.png')" class="iconimg" />
        <p>活动</p>
        <img v-lazy="require('../../assets/imgs/iphone_4.png')" class="iconimg" />
        <p>英文测评</p>
      </el-col>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="6">
        <img v-lazy="require('../../assets/imgs/iphone_3.png')" class="iconimg" />
        <p>绘本朗读</p>
        <img v-lazy="require('../../assets/imgs/iphone_5.png')" class="iconimg" />
        <p>中文测评</p>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
    </el-row>
    <el-row>
      <el-col :span="4">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_ldttitle3.png')" class="titleimg" />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="5">&nbsp;</el-col>
      <el-col :span="14">
        <img v-lazy="require('../../assets/imgs/iphone_ldt_title1.png')" class="ldt_titleimg" />
        <img v-lazy="require('../../assets/imgs/iphone_ldt2_back.png')" class="ldtback" />
        <el-carousel trigger="click" :loop="true" height="40vh" class="ldt_siwper" indicator-position="outside">
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/ldt1.png')" class="ldt_detailimg" />
          </el-carousel-item>
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/ldt6.png')" class="ldt_detailimg" />
          </el-carousel-item>
        </el-carousel>
      </el-col>
      <el-col :span="5">&nbsp;</el-col>
    </el-row>
    <el-row>
      <el-col :span="5">&nbsp;</el-col>
      <el-col :span="14">
        <img v-lazy="require('../../assets/imgs/iphone_ldt_title2.png')" class="ldt_titleimg" />
        <img v-lazy="require('../../assets/imgs/iphone_ldt3_back.png')" class="ldtback ldtback2" />
        <el-carousel trigger="click" :loop="true" height="40vh" class="ldt_siwper" indicator-position="outside">
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/ldt2.png')" class="ldt_detailimg" />
          </el-carousel-item>
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/ldt4.png')" class="ldt_detailimg" />
          </el-carousel-item>
        </el-carousel>
      </el-col>
      <el-col :span="5">&nbsp;</el-col>
    </el-row>
    <el-row>
      <el-col :span="4">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_ldttitle4.png')" class="titleimg" />
      </el-col>
    </el-row>
    <el-row>
      <p style="color:#999999;text-aligin:center;margin-bottom:3vh">
        行知朗读亭，为您打造朗读空间。
      </p>
    </el-row>
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20">
        <el-carousel trigger="click" :loop="true" height="20vh" indicator-position="outside">
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/Reading_room1.png')" class="img" />
          </el-carousel-item>
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/Recreational_area.png')" class="img" />
          </el-carousel-item>
          <el-carousel-item>
            <img v-lazy="require('../../assets/imgs/The_library.png')" class="img" />
          </el-carousel-item>
        </el-carousel>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
    </el-row>
    <el-row>
      <el-col :span="4">&nbsp;</el-col>
      <el-col class="title">
        <img v-lazy="require('../../assets/imgs/iphone_ldttitle5.png')" class="titleimg" />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="22">
        <el-table stripe id="table" style="width: 100%" :data="tableData">
          <el-table-column prop="name" label="标题" style="width:50%">
          </el-table-column>
          <el-table-column prop="data" label="规格" style="width:50%">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="1">&nbsp;</el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "iphoneLdt",
  data () {
    return {
      tableData: [
        {
          name: "设备主体",
          data: "朗读亭一台（含空调、通风系统、灯光、射灯、玻璃）"
        },
        { name: "V G V:", data: "最高可支持1920*1080@fps" },
        { name: "操作系统:", data: "安卓系统" },
        {
          name: "C P U:",
          data:
            "触摸点播系统（屏）1 个，21.5液晶\n影像字幕显示屏1 个，32寸液晶\n 主控机1 个"
        },
        { name: "显示部分:", data: "安卓系统" },
        { name: "产品尺寸:", data: "1.26*1.56*2.70M" },
        { name: "额定电源:", data: "AC220V 50HZ" },
        { name: "无线连接:", data: "支持网线、WIFI" },
        { name: "额定功率:", data: "整机为800W,包含空调和通风系统" },
        {
          name: "屏幕类型:",
          data: "主显示器分辨率1920*1080\n触摸屏分辨率，1920*1080"
        },
        { name: "软件升级:", data: "支持本地升级/OTA升级" },
        {
          name: "设备附件:",
          data:
            "专业电容麦克风2个\n专业监听头戴式耳机2个\n空调遥控器1个\n复古座椅2个\n小吧台2个"
        },
        { name: "附加功能:", data: "臭氧消毒" }
      ]
    };
  }
};
</script>
<style scoped>
.title {
  margin-top: 5vh;
  margin-bottom: 4vh;
  height: 2.5vh;
  width: auto;
}
.titleimg {
  width: auto;
  height: 100%;
}
.titleimgbig {
  width: 40vw;
  height: 2.8vh;
}

.two,
.four,
.six {
  background-color: white;
}
.bird {
  position: absolute;
  z-index: 999;
  left: 5vw;
  width: 50px;
  height: 50px;
  top: -5vh;
}
.showimg {
  width: 100%;
}
.ldtimg {
  height: auto;
  position: relative;
}
.ldtimg2 {
  height: 17vh;
  width: 55vw;
  left: -5vw;
  top: 5vh;
}
.ldtimg3 {
  height: 27vh;
}
.ldtimg5 {
  height: 18vh;
  width: 80vw;
  left: -30vw;
}
.ldtimg6 {
  width: 50vw;
  right: -5vw;
  top: 3vh;
}
.ldt_siwper {
  position: relative;
  z-index: 999;
  height: 44vh;
  margin-top: 2vh;
  margin-bottom: 5vh;
}
.ldt_detailimg {
  width: 100%;
  height: 100%;
}
.number {
  display: inline-block;
  width: 20px;
  height: 16px;
}
.ldt_title {
  display: inline-block;
  font-size: 18px;
  font-weight: bolder;
  position: relative;
  top: -0.2vh;
  left: 1vw;
}
.ldt_title1 {
  margin-top: 3vh;
  text-align: left;
}
.ldt_title_detail {
  display: inline-block;
  color: #999999;
  margin-top: 4vh;
  text-align: left;
  margin-bottom: 2vh;
}
.line1 {
  height: 6vh;
  position: absolute;
  top: 7vh;
  z-index: 999;
  right: 5vw;
}
.line2 {
  height: 6vh;
  position: absolute;
  top: 7vh;
  z-index: 999;
  right: 16.5vw;
}
.iconimg {
  width: 70px;
  height: 70px;
  display: inline-block;
  margin-bottom: 1vh;
  font-weight: bolder;
  margin-top: 1vh;
}
.ldt_titleimg {
  position: absolute;
  z-index: 999;
  left: 10vw;
  height: 22px;
  top: -2vh;
}
.ldtback {
  position: absolute;
  left: -18vw;
  top: 2vh;
  width: 100%;
}
.ldtback2 {
  left: 0;
  top: -7vh;
}
.ldtback3 {
  left: 10vw;
  top: -5vh;
}
.img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/iphone/ldt.vue